import { render } from "./BatchClassAttributesView.vue?vue&type=template&id=e3127268&scoped=true&ts=true"
import script from "./BatchClassAttributesView.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributesView.vue?vue&type=script&lang=ts"

import "./BatchClassAttributesView.vue?vue&type=style&index=0&id=e3127268&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3127268"]])

export default __exports__